module.exports = __webpack_public_path__ + "img/file-text.b56b5a56.svg";